import React from 'react'

function LearningHubCoursesIcon() {
  return (
    <svg
      width="86"
      height="84"
      viewBox="0 0 86 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        className="fill"
        d="M85.7014 42C85.7014 65.196 66.8072 84 43.5 84C20.1927 84 1.29846 65.196 1.29846 42C1.29846 18.804 20.1927 0 43.5 0C54.6925 0 65.4266 4.42499 73.3409 12.3015C81.2552 20.178 85.7014 30.8609 85.7014 42Z"
        fill="#2B0AAF"
      />
      <g transform="translate(17, 23.5)">
        <path
          d="M28.3636 30.1781C30.097 29.3687 31.8402 28.7617 33.5932 28.357C35.3462 27.9523 37.1485 27.75 39 27.75C40.4182 27.75 41.8068 27.8656 43.1659 28.0969C44.525 28.3281 45.8939 28.675 47.2727 29.1375V6.24375C45.9727 5.70417 44.6235 5.29948 43.225 5.02969C41.8265 4.7599 40.4182 4.625 39 4.625C37.1485 4.625 35.3167 4.85625 33.5045 5.31875C31.6924 5.78125 29.9788 6.475 28.3636 7.4V30.1781ZM26 37C24.1091 35.5354 22.0606 34.3984 19.8545 33.5891C17.6485 32.7797 15.3636 32.375 13 32.375C11.3455 32.375 9.72046 32.587 8.125 33.0109C6.52955 33.4349 5.00303 34.0323 3.54545 34.8031C2.71818 35.2271 1.92045 35.2078 1.15227 34.7453C0.384091 34.2828 0 33.6083 0 32.7219V4.85625C0 4.43229 0.108333 4.0276 0.325 3.64219C0.541667 3.25677 0.866667 2.96771 1.3 2.775C3.11212 1.85 5.00303 1.15625 6.97273 0.69375C8.94242 0.23125 10.9515 0 13 0C15.2848 0 17.5205 0.289062 19.7068 0.867188C21.8932 1.44531 23.9909 2.3125 26 3.46875C28.0091 2.3125 30.1068 1.44531 32.2932 0.867188C34.4795 0.289062 36.7152 0 39 0C41.0485 0 43.0576 0.23125 45.0273 0.69375C46.997 1.15625 48.8879 1.85 50.7 2.775C51.1333 2.96771 51.4583 3.25677 51.675 3.64219C51.8917 4.0276 52 4.43229 52 4.85625V32.7219C52 33.6083 51.6159 34.2828 50.8477 34.7453C50.0795 35.2078 49.2818 35.2271 48.4546 34.8031C46.997 34.0323 45.4705 33.4349 43.875 33.0109C42.2795 32.587 40.6545 32.375 39 32.375C36.6364 32.375 34.3515 32.7797 32.1455 33.5891C29.9394 34.3984 27.8909 35.5354 26 37Z"
          fill="#FFFFFF"
        />
      </g>
    </svg>
  )
}

export default LearningHubCoursesIcon
